import { api } from '../apiClient';

export const passwordAPI = {
  changePassword: (currentPassword: string, newPassword: string) => {
    return api.post('/password/change', { 
      current_password: currentPassword, 
      new_password: newPassword 
    }).then(response => response.data);
  },
  
  requestReset: (email: string) => {
    return api.post('/password/reset-request', { email }).then(response => response.data);
  },
  
  confirmReset: (token: string, newPassword: string) => {
    return api.post('/password/reset-confirm', { 
      token, 
      new_password: newPassword 
    }).then(response => response.data);
  }
};

